module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/alerta/alerta.component.css
// module id = ./src/app/alerta/alerta.component.css
// module chunks = main